import { useEffect, useState } from 'react'
import 'react-reflex/styles.css'
import { paneMaxHeight } from '../../../../pages/[lang]/portal/lessons/preparation/[lessonId]'
import { TextProvider } from '../../../../pages/[lang]/portal/materials/detail/[materialId]'

import useQuestionStore from '../../../../store/useQuestionStore'
import { TAB } from '../../../materials/const'
import { FileUploadBody } from '../../../new-portal/materials/FileUploadBody'
import MaterialInsightBody from '../../../new-portal/materials/MaterialInsightBody'
import MediaPanel from '../../../new-portal/materials/MediaPanel'
import { QuestionSelectPanel } from '../../../new-portal/materials/QuestionSelect/QuestionSelectPanel'

type TabBodyPropsType = {
  lesson: any
  currentTab: any
  currentUser: any
  materialRef: any
}

const StudentClassroomTabBody = ({ lesson, currentTab, currentUser, materialRef }: TabBodyPropsType) => {
  const isFreeTalkingOrWriting = lesson.course?.free_talking || lesson.course?.is_writing
  const [isEditable, setIsEditable] = useState([])
  const [answer, setAnswer] = useState('')
  const [tabData, setTabData] = useState([])
  const [selectedShareState, setSelectedShareState] = useState<number>(0)
  const [activeQuestionId, setActiveQuestionId] = useState(null)

  const course = lesson.course
  const media = {
    youtubes: course.video,
    articles: course.article,
  }
  const noMedia = media.youtubes?.length == 0 && media.articles?.length == 0
  const reset = useQuestionStore((state) => state.reset)

  useEffect(() => {
    return () => {
      reset()
    }
  }, [])

  return (
    <div style={{ maxHeight: paneMaxHeight }} className="no-scrollbar overflow-y-auto px-[32px]">
      {currentTab == TAB.INSIGHT && (
        <div className="px-[32px] pt-[32px]">
          <TextProvider>
            <MaterialInsightBody materialData={lesson} materialId={lesson.course.id} currentUser={currentUser} />
          </TextProvider>
        </div>
      )}
      {currentTab === TAB.UPLOAD_FILE && <FileUploadBody materialRef={materialRef} lesson={lesson} />}

      {currentTab === TAB.QUESTION_SELECT && (
        <div className="mt-[40px]">
          <QuestionSelectPanel
            currentUser={currentUser}
            isReview={false}
            isLesson={true}
            isEditable={isEditable}
            setIsEditable={setIsEditable}
            answer={answer}
            setAnswer={setAnswer}
            setTabData={setTabData}
            selectedShareState={selectedShareState}
            setSelectedShareState={setSelectedShareState}
            activeQuestionId={activeQuestionId}
            setActiveQuestionId={setActiveQuestionId}
          />
        </div>
      )}
      {currentTab == TAB.MEDIA && !isFreeTalkingOrWriting && (
        <MediaPanel media={media} noMedia={noMedia} course={course} />
      )}
    </div>
  )
}

export default StudentClassroomTabBody
